module.exports = __webpack_public_path__ + "static/media/ProfilePic.9efe3575.png";